import cashDeskPublicInstance from './instance'

const getPublicCartState = () => {
	return cashDeskPublicInstance.get('/publicCartState')
}

export default getPublicCartState
